import { StytchB2B, useStytchMemberSession } from "@stytch/react/b2b";

import Card from "@mui/material/Card";
import Link from "@mui/material/Link";
import { AuthFlowType, B2BProducts } from "@stytch/vanilla-js";
import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import AuthenticateError from "../authentication/AuthenticateError";
import EnvLogo from "../components/env/EnvLogo";
import Flx from "../components/layout/Flx";
import Txt from "../components/typography/Txt";
import { useEnv } from "../hooks/useEnv";

const LoginScreen = () => {
  const { session } = useStytchMemberSession();
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { isResilender } = useEnv();
  if (session) {
    return <Navigate to="/" />;
  }

  const config = {
    products: [B2BProducts.emailMagicLinks],
    sessionOptions: { sessionDurationMinutes: 10080 },
    authFlowType: AuthFlowType.Discovery,
    emailMagicLinksOptions: {
      loginRedirectURL: `${window.location.origin}/authenticate`,
      discoveryRedirectURL: `${window.location.origin}/authenticate`,
    },
    ssoOptions: {
      loginRedirectURL: `${window.location.origin}/authenticate`,
      discoveryRedirectURL: `${window.location.origin}/authenticate`,
    },
  };

  if (error) {
    return <AuthenticateError />;
  }

  return (
    <Flx
      center
      column
      sx={{
        p: 2,

        overflow: "hidden",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        div: {
          border: "none",
        },
      }}
    >
      <Card
        sx={{
          pb: isResilender ? 4 : 2,
          position: "relative",
        }}
      >
        <Flx center column>
          <EnvLogo sx={{ mt: 2 }} />
          <StytchB2B
            config={config}
            callbacks={{
              onError: () => {
                setError(true);
              },
            }}
            styles={{
              fontFamily: `"IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell,
            "Helvetica Neue", sans-serif`,
              buttons: {
                primary: {
                  backgroundColor: "#2962ff",
                  borderColor: "#2962ff",
                },
              },
              container: {
                borderColor: "#00000024",
              },
              inputs: {
                borderColor: "#0000003b",
              },
            }}
          />
        </Flx>
        {isResilender ? (
          <Flx
            center
            gap={0.8}
            sx={{
              left: 0,
              height: "80px",
              // mt: 2,
              position: "absolute",
              bottom: 0,
              width: "100%",
              background: "#ffffff",
              // background: "red",
            }}
          >
            <Txt>New to Resilender?</Txt>
            <Link
              onClick={() => navigate("/sign-up")}
              sx={{ textDecoration: "none", cursor: "pointer" }}
            >
              <Txt> Create an account</Txt>
            </Link>
          </Flx>
        ) : null}
      </Card>
    </Flx>
  );
};

export default LoginScreen;
